import { j as r } from "./atoms-v218.js";
import { AddOns as e } from "./atoms-v285.js";
import { Amenities as t } from "./atoms-v286.js";
import { BookingConfirmationHeader as m } from "./atoms-v287.js";
import { CardList as s } from "./atoms-v288.js";
import { CheckoutFooter as i } from "./atoms-v289.js";
import { Description as c } from "./atoms-v290.js";
import { Footer as p } from "./atoms-v291.js";
import { Gallery as n } from "./atoms-v292.js";
import { Policy as a } from "./atoms-v293.js";
import { RateCard as f } from "./atoms-v294.js";
import { Rates as l } from "./atoms-v295.js";
import { UpgradeRoom as d } from "./atoms-v296.js";
const o = () => /* @__PURE__ */ r.jsx("div", { children: "The Blocks component should not be referenced directly. Please use the Blocks namespace to access its components (e.g. <Blocks.Description />)." });
o.displayName = "Blocks";
const F = Object.assign(o, {
  AddOns: e,
  Amenities: t,
  BookingConfirmationHeader: m,
  CardList: s,
  CheckoutFooter: i,
  Description: c,
  Footer: p,
  Gallery: n,
  Policy: a,
  RateCard: f,
  Rates: l,
  UpgradeRoom: d
});
export {
  F as Blocks
};
